import { SelectOption } from '@/components/elements/select'

export const activeMap: SelectOption[] = [
    { label: 'Visible en la tienda', value: true },
    { label: 'Oculto', value: false },
]
